import { useQuery } from '@tanstack/react-query';

import StepLib from '@/models/StepLibData';

type UseStepLibResponse = {
  data: null | StepLib;
  isLoading: boolean;
};

const useStepLib = (): UseStepLibResponse => {
  const { data, isLoading } = useQuery({
    queryKey: ['steplib'],

    queryFn: async () => {
      const response = await fetch('https://bitrise-steplib-collection.s3.amazonaws.com/slim-spec.json.gz');
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    },
  });

  return {
    data,
    isLoading,
  };
};

export default useStepLib;
